import { BaSeInput } from "@base/react"

export default function InputNumber({
                                      name,
                                      value,
                                      onFnExternalChange,
                                      label,
                                      placeholder,
                                      subLabel,
                                      maxLength = 22,
                                      allowNegative = false,
                                      maxValue = 100,
                                      inputStatus = "",
                                      ...props
                                    }) {
  const handleInputChange = (e) => {
    let cleaned = e.toString().replace(/[^\d-]/g, "")
    if (!allowNegative) {
      cleaned = cleaned.replace(/-/g, "")
    } else if (cleaned.includes("-")) {
      cleaned = "-" + cleaned.replace(/-/g, "")
    }

    let numericValue = parseInt(cleaned, 10)
    if (isNaN(numericValue)) numericValue = 0
    if (numericValue > maxValue) numericValue = maxValue
    if (allowNegative && numericValue < -maxValue) numericValue = -maxValue

    onFnExternalChange && onFnExternalChange(numericValue)

    return numericValue
  }

  return (
    <div className={`wrapper-input ${inputStatus}`}>
      <BaSeInput
        name={name}
        value={value === undefined || value === null ? "" : String(value)}
        onChange={handleInputChange}
        label={label}
        placeholder={placeholder}
        subLabel={subLabel}
        inputStatus={inputStatus}
        size="medium"
        width="100%"
        inputMode="tel"
        typeInput="tel"
        maxLength={maxLength}
        {...props}
      />
    </div>
  )
}
